module.exports = __webpack_public_path__ + "img/angular.639e3b03.png";